<template>
    <div class="content-page">
        <div class="container-fluid">
            <div class="row" v-if="permissions">
                <div class="col-lg-12">
                    <div class="type_package" v-if="see_form == true">
                        <form  class="form" action="" @submit.prevent="importmenu">
                            Click here if you don't have a model <button type="button" class="btn m-10 btn-primary add-list pull-right" @click="exportmodel">Export</button>
                            <br><br>
                            <input class="btn col-lg-9 mr-3 btn-primary add-list" type="file" name="" id="file" ref="photos" >
                            <button class="btn m-10 btn-primary add-list" type="submit">OK</button><br><br>
                            <button type="button" class="btn m-10 btn-primary add-list pull-right" @click="back">Back</button>
                        </form>
                    </div>
                    <div class="d-flex flex-wrap align-items-center justify-content-between mb-4">
                        <div>
                            <h4 class="mb-3">Users list</h4>
                        </div>
                        <a href="/create-user" v-if="permissions.includes('create-users')" class="btn btn-primary add-list" ><i class="las la-plus mr-3"></i>Add a user</a>
                        <a @click="see" v-if="permissions.includes('show-users')" class="btn btn-primary add-list" ><i class="las la-plus mr-3"></i>Add users by file</a>
                        <a @click="resetU" v-if="permissions.includes('reset-balance')" class="btn btn-primary add-list" ><i class="las la-plus mr-3"></i>Reset all balances</a>
                        <a @click="disableUsers" v-if="permissions.includes('reset-balance')" class="btn btn-primary add-list" ><i class="las la-plus mr-3"></i>Disable users account</a>
                        <button @click="printData()" class="btn mt-10 btn-primary mr-2">Print</button>
                    </div>
                </div>
                <div class="col-lg-12">
                    <div class="users-search d-flex justify-content-end mb-3">
                        <input
                            v-model="userSearch"
                            type="search"
                            class="form-control"
                            placeholder="Search by ID, email, name, phone or profile"
                            aria-label="Search users"
                        >
                    </div>
                    <div class="users-table-wrapper table-responsive rounded mb-3">
                    <table id="example" class="users-table data-table table mb-0 tbl-server-info">
                        <thead class="bg-white text-uppercase">
                            <tr class="ligth ligth-data">
                                <th>ID</th>
                                <th>Email</th>
                                <th>Last name</th>
                                <th>First name</th>
                                <th>Profile</th>
                                <th v-if="permissions.includes('show-users') || permissions.includes('delete-users')">Actions</th>
                            </tr>
                        </thead>
                        <tbody class="ligth-body">
                            <tr v-for="(user,index) in filteredUsers" :key="index">
                                <td>{{user.matricule}}</td>
                                <td>{{user.email}}</td>
                                <td>{{user.nom}}</td>
                                <td>{{user.prenoms}}</td>  
                                <td> {{ user.function }} </td>
                                <td v-if="permissions.includes('show-users') || permissions.includes('delete-users')">
                                    <div class="d-flex align-items-center list-action">
                                        <router-link :to="'/show-user/'+user.id" v-if="permissions.includes('show-users')"
                                                    class="badge badge-info mr-2" data-toggle="tooltip" data-placement="top" 
                                                    title="" data-original-title="View"><i class="fa fa-eye mr-0"></i>
                                        </router-link>

                                        <button v-if="permissions.includes('delete-users')"  class="badge badge-info bg-warning mr-2 btn" data-toggle="tooltip" data-placement="top" title="" data-original-title="Delete"
                                            @click="destroy(user.id)"><i class="fa fa-trash mr-0"></i></button>
                                        <button v-if="permissions.includes('enable/disable accounts') && user.active == 0" type="btn"  class="badge badge-info bg-secondary btn mr-2" data-toggle="tooltip" data-placement="top" title="" data-original-title="Delete"
                                            @click="active(user.id,1)"><i class="fa fa-lock mr-0"></i></button>
                                        <button v-if="permissions.includes('enable/disable accounts') && user.active == 1" type="btn"  class="badge badge-info bg-secondary btn mr-2" data-toggle="tooltip" data-placement="top" title="" data-original-title="Delete"
                                            @click="active(user.id,0)"><i class="fa fa-unlock mr-0"></i></button>
                                        <button v-if="permissions.includes('reset-balance')" type="btn"  class="badge badge-info bg-secondary btn mr-2" data-toggle="tooltip" data-placement="top" title="" data-original-title="Delete"
                                            @click="bankrupt(user.id)"><i class="fa fa-credit-card mr-0"></i></button>
                                    </div>
                                </td>
                            </tr>
                            
                            
                        </tbody>
                    </table>
                    <table id="exampleZ" class="data-table table mb-0 tbl-server-info">
                        <thead class="bg-white text-uppercase">
                            <tr class="ligth ligth-data">
                                <th>ID</th>
                                <th>Last name</th>
                                <th>First name</th>
                                <th>Balance</th>
                            </tr>
                        </thead>
                        <tbody class="ligth-body">
                            <tr v-for="(user,index) in users" :key="index">
                                <td>{{user.matricule}}</td>
                                <td>{{user.nom}}</td>
                                <td>{{user.prenoms}}</td>  
                                <td>{{user.solde}}</td> 
                            </tr>
                            
                            
                        </tbody>
                    </table>
                </div>
                <div class="vld-parent">
                    <loading v-model:active="isLoading"
                    :can-cancel="true" 
                    :is-full-page="fullPage"></loading>
                </div>
            </div>
        </div>
        </div>
    </div>
</template>
<style>
.users-table {
    min-width: 760px;
}

.users-search input {
    max-width: 360px;
}

.users-table th:last-child,
.users-table td:last-child {
    position: sticky;
    right: 0;
    z-index: 1;
    min-width: 120px;
    white-space: nowrap;
    background-color: #fff;
    box-shadow: -4px 0 8px rgba(0, 0, 0, 0.08);
}

.users-table thead th:last-child {
    z-index: 2;
    background-color: #f4f5fa;
}

#exampleZ {
    display: none;
}
</style>
<script>
import axios from "axios";

// Import component
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/css/index.css';
import Swal from 'sweetalert2'
export default {
    components: {
            Loading
    },
    data() {
        return {
            permissions: [],
            users:{},
            userSearch: '',
            isLoading: false,
            fullPage: true,
            see_form: false,
        };
    },
    mounted(){
        this.$store.state.user.permissions.forEach(element => {
            this.permissions.push(element.name)
        });
        this.getusers()
    },
    computed: {
        filteredUsers() {
            const search = this.userSearch.trim().toLowerCase()
            const users = Array.isArray(this.users) ? this.users : []

            if (!search) {
                return users
            }

            return users.filter(user => [
                user.matricule,
                user.email,
                user.nom,
                user.prenoms,
                user.phone,
                user.function,
            ].some(value => String(value || '').toLowerCase().includes(search)))
        },
    },
    methods:{
        printData()
        {
        var divToPrint=document.getElementById("exampleZ");
        divToPrint.style.textAlign = "center"
        let newWin= window.open("");
        newWin.document.write(divToPrint.outerHTML);
        newWin.print();
        newWin.close();
        },
        exportmodel () {
            this.isLoading = true
            axios.get('users-export', { responseType: 'blob' })
                .then(response => {
                    const contentDisposition = response.headers['content-disposition'] || ''
                    const filenameMatch = contentDisposition.match(/filename\*?=(?:UTF-8''|"?)([^;"\r\n]+)/i)
                    const filename = filenameMatch ? decodeURIComponent(filenameMatch[1]) : 'userImport.xlsx'
                    const downloadUrl = window.URL.createObjectURL(response.data)
                    const downloadLink = document.createElement('a')

                    downloadLink.href = downloadUrl
                    downloadLink.download = filename
                    document.body.appendChild(downloadLink)
                    downloadLink.click()
                    downloadLink.remove()
                    window.URL.revokeObjectURL(downloadUrl)

                    Swal.fire('Success', 'Model exported successfully', 'success')
                })
                .catch(error => {
                    Swal.fire('Failure', 'An error occured, model not exported', 'error')
                    console.log(error)
                })
                .finally(() => {
                    this.isLoading = false
                })
        },
        see(){
            this.see_form = true
        },
        back(){
            this.see_form = false
        },
        importmenu(){
                    let app = this
                    app.isLoading = true
                    var menuData = new FormData();
                    app.photos = app.$refs.photos.files
                    let file = app.photos[0];
                    console.log(file)
                    if (file != null) {
                        menuData.append('file', file);
                        axios.post('users-excel', menuData,{
                            headers: {"Access-Control-Allow-Origin": "*"}

                        })
                        .then(function (reponse){
                            app.isLoading = false
                            Swal.fire('Success', 'Users added', 'success')
                            console.log(reponse);
                        })
                        .catch(function (error){
                            Swal.fire('Failure', 'An error occured, users not added', 'error')
                            console.log(error);
                        })
                        .finally(function () {
                            app.isLoading = false
                        })
                        app.see_form = false
                    } else {
                        app.isLoading = false
                    }
        },
        async resetU () {
            const { value: fruit } = await Swal.fire({
                title: 'Select field validation',
                input: 'select',
                inputOptions: {
                    'Student': 'Student',
                    'Staff': 'Staff',
                },
                inputPlaceholder: 'Select a profile',
                showCancelButton: true,
                inputValidator: (value) => {
                    return new Promise((resolve) => {
                    if (value) {
                        resolve()
                    } else {
                        resolve('Choose a profile')
                    }
                    })
                }
            })

            if (fruit) {
                axios.post('resetUser', {role: fruit})
                .then(function (rep) {
                    console.log(rep);
                    if (rep.data.status == true) {
                        Swal.fire('Successful', 'Balances reset', 'success')
                    } else {
                        Swal.fire('Warning', rep.data.message, 'warning')
                    }
                })
                .catch(function (err) {
                    console.log(err);
                    Swal.fire('Error', 'An unknown error occured', 'error')
                })
            }
        },
        async disableUsers () {
            const { value: fruit } = await Swal.fire({
                title: 'Select entitie',
                input: 'select',
                inputOptions: {
                    'Student': 'Student',
                    'Staff': 'Staff',
                },
                inputPlaceholder: 'Select a profile',
                showCancelButton: true,
                inputValidator: (value) => {
                    return new Promise((resolve) => {
                    if (value) {
                        resolve()
                    } else {
                        resolve('Choose a profile')
                    }
                    })
                }
            })

            if (fruit) {
                axios.post('disable-users', {role: fruit})
                .then(function (rep) {
                    console.log(rep);
                    if (rep.data.status == true) {
                        Swal.fire('Successful', 'Balances reset', 'success')
                    } else {
                        Swal.fire('Warning', rep.data.message, 'warning')
                    }
                })
                .catch(function (err) {
                    console.log(err);
                    Swal.fire('Error', 'An unknown error occured', 'error')
                })
            }
        },
        getusers() {
            this.isLoading =  true
            axios.get('users')
            .then(response => {
                console.log(response)
                if (response.data.status == true) {
                this.users = response.data.data
                }
            })
            .catch(error => {
                console.log(error)
                this.errored = true
                Swal.fire(
                        'Error!',
                        'An error occured while fetching datas',
                        'error'
                )
            })
            .finally(() => {
                this.isLoading = false
            })
        },
        destroy(id) {
            Swal.fire({
                title: 'Do you want to delete this user?',
                text: "This action is irreversible!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete!'
            }).then((result) => {
                if (result.isConfirmed) {
                    this.isLoading =  true
                    axios.delete('users/'+id)
                    .then(response => {
                        console.log(response.data)
                        this.users = response.data
                        this.isLoading =  false
                        Swal.fire(
                            'Deleted!',
                            'The user was deleted.',
                            'success'
                        )
                        location.reload()
                    })
                    .catch(error => {
                        console.log(error)
                        this.errored = true
                        this.isLoading =  false
                    })
                }
            })
            
        },
        bankrupt(id) {
            Swal.fire({
                title: "Do you want to reset this user's balance?",
                text: "This action is irreversible!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, reset!'
            }).then((result) => {
                if (result.isConfirmed) {
                    this.isLoading =  true
                    axios.post('bankruptUser', {id: id})
                    .then(response => {
                        console.log(response.data)
                        this.users = response.data
                        this.isLoading =  false
                        Swal.fire(
                            'Reset!',
                            'The user was reset.',
                            'success'
                        )
                        location.reload()
                    })
                    .catch(error => {
                        console.log(error)
                        this.errored = true
                        this.isLoading =  false
                    })
                }
            })
            
        },
        active(userID,id) {
            let app = this
            Swal.fire({
                title: 'do you want to enable/disable this account?',
                text: "This action is irreversible!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes!'
            }).then((result) => {
                if (result.isConfirmed) {
                    this.isLoading =  true
                    axios.put('users-status/'+userID,{
                        active:id
                    })
                    .then(response => {
                        console.log(response.data)
                        this.isLoading =  false
                        if (id == 0) {
                            Swal.fire(
                                'Success!',
                                'account Disabled',
                                'success'
                            )
                        } else {
                            Swal.fire(
                                'Success!',
                                'activated account',
                                'success'
                            )
                        }
                        
                        app.getusers()
                    })
                    .catch(error => {
                        console.log(error)
                        this.errored = true
                        this.isLoading =  false
                    })
                }
            })
            
        },
    }
}
</script>